export default __webpack_public_path__ + "static/media/ellipse2.d58e2307.svg";